import { CpIcon } from 'assets/icons/CpSideBar.icon';
import { CpOrangeIcon } from 'assets/icons/CpOrange.icon';
import { UserIcon } from 'assets/icons/User.icon';
import { UserOrangeIcon } from 'assets/icons/UserOrange.icon';
import { PatientPIcon } from 'assets/icons/PatientP.icon';
import { PatientPOrangeIcon } from 'assets/icons/PatientPOrange.icon';
import { AuditIcon } from 'assets/icons/Audit.icon';
import { AuditOrangeIcon } from 'assets/icons/AuditOrange.icon';
import { SiteIcon } from 'assets/icons/Site.icon';
import { SiteOrangeIcon } from 'assets/icons/SiteOrange.icon';

export enum orderBy {
  ASC = 'asc',
  DESC = 'desc'
}

export enum pagesEnum {
  SITES = 'sites',
  USERS_AND_PERMISSIONS = 'users-and-permission',
  CP = 'cp',
  PATIENTS = 'patients',
  AUDIT = 'audit'
}

export const DASHBOARD_BASE = '/';

export const DashboardPages = [
  {
    name: pagesEnum.SITES,
    link: '/' + pagesEnum.SITES,
    icon: SiteIcon,
    selectedIcon: SiteOrangeIcon
  },
  {
    name: pagesEnum.USERS_AND_PERMISSIONS,
    link: DASHBOARD_BASE + pagesEnum.USERS_AND_PERMISSIONS,
    icon: UserIcon,
    selectedIcon: UserOrangeIcon
  },
  {
    name: pagesEnum.CP,
    link: DASHBOARD_BASE + pagesEnum.CP,
    icon: CpIcon,
    selectedIcon: CpOrangeIcon
  },
  {
    name: pagesEnum.PATIENTS,
    link: DASHBOARD_BASE + pagesEnum.PATIENTS,
    icon: PatientPIcon,
    selectedIcon: PatientPOrangeIcon
  },
  {
    name: pagesEnum.AUDIT,
    link: DASHBOARD_BASE + pagesEnum.AUDIT,
    icon: AuditIcon,
    selectedIcon: AuditOrangeIcon
  }
];

export const searchSourceToPages = (source: string) => {
  switch (source) {
    case 'site':
      return pagesEnum.SITES;
    case 'user':
      return pagesEnum.USERS_AND_PERMISSIONS;
    case 'cp':
      return pagesEnum.CP;
    case 'patient':
      return pagesEnum.PATIENTS;
    default:
      break;
  }
};

export enum timing {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  DATE = 'dd.MM.yyyy',
  DATE_FOR_SERVICE = 'yyyy-MM-dd',
  FULLDATE = 'dd.MM.yyyy hh:mm a',
  TIME = 'hh:mm a',
  MONTH_DAY = 'MMM dd, yyyy',
  DATE_MONTH = 'dd MMMM yyyy'
}
